<template>
    <div class="c-dashboard__wrap" v-if="currentDate"
        :data-component-name="$options.name"
    >
        <WeekView
            v-if="currentView=='weekView'"
            :currentDate="currentDate"
            :shiftsView="shiftsView"
            :projectsFilter="projectsFilter"
            :scrollToProject="scrollToProject"
            @set-current-date="$emit('set-current-date', $event)"
            @new-project="NewProject=true"
        />
        <MonthView
            v-if="currentView=='monthView'"
            :projectsFilter="projectsFilter"
            :shiftsView="shiftsView"
            :currentDate="currentDate"
            :scrollToProject="scrollToProject"
            @set-current-date="$emit('set-current-date', $event)"
            @set-current-view="$emit('set-current-view', $event)"
            @jump-to-project-week="$emit('jump-to-project-week', $event)"
            @new-project="NewProject=true"
        />
        <!-- <MonthView
            v-if="currentView=='monthView'"
            :projectsFilter="projectsFilter"
            :currentDate="currentDate"
            @set-current-date="setCurrentDate($event)"
            @new-project="NewProject=true"
        /> -->
    </div>
</template>

<script>
    import WeekView from '@/components/dashboard/WeekView';
    import MonthView from '@/components/dashboard/MonthView';

    export default {
        name: 'ProjectsDashboard',
        components: {
            WeekView,
            MonthView
        },
        props: {
            currentView: {
                type: String,
                default: 'weekView'
            },
            shiftsView: {
                type: String,
                default: 'profession'
            },
            projectsFilter: {
                type: String,
                default: 'All'
            },
            currentDate: {
                type: String,
                default: null
            },
            scrollToProject: {
                type: String,
                default: null
            },
        },
        data(){
            return {
                // currentDate: null,
                newProject: false,
                // scrollToProject: null
            }
        },
        computed: {
        },
        mounted: function(){
        },
        methods: {
            // getCurrentDate(){
            //     let storedDate = this.$q.localStorage.getItem('currentDate');
            //     if(storedDate){
            //         this.currentDate=storedDate;
            //     }else{
            //         this.currentDate=moment(this.date).format("YYYY-MM-DD");
            //     }
            // },
            // setCurrentDate(date){
            //     this.$q.localStorage.set('currentDate', date)
            //     this.scrollToProject=null
            //     this.currentDate=date
            // },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/scss/views/Dashboard.scss";
</style>
